@if (sent()) {
  <div class="done">
    <div class="done-icon">
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--acc)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
    </div>
    <h2 class="done-title">Dziękujemy!</h2>
    <p class="done-sub">Wiadomość dotarła. Odezwiemy się na podany adres najszybciej, jak to możliwe.</p>
    <button (click)="reset()" class="again-btn">Wyślij kolejną</button>
  </div>
} @else {
  <div class="form">
    <div class="wl-form-row">
      <div>
        <label>Imię i nazwisko</label>
        <input [(ngModel)]="name" placeholder="Anna Kowalska" [style.background]="inputBg" />
      </div>
      <div>
        <label>E-mail</label>
        <input [(ngModel)]="email" type="email" placeholder="anna@email.com" [style.background]="inputBg" />
      </div>
    </div>
    <div>
      <label>Temat</label>
      <select [(ngModel)]="topic" [style.background-color]="inputBg">
        @for (t of topics; track t) {
          <option [value]="t">{{ t }}</option>
        }
      </select>
    </div>
    <div>
      <label>Wiadomość</label>
      <textarea [(ngModel)]="message" rows="5" placeholder="Opowiedz nam czego potrzebujesz…" [style.background]="inputBg"></textarea>
    </div>

    <!-- Honeypot: ukryte pole, boty wypełniają -->
    <input [(ngModel)]="company" name="company" tabindex="-1" autocomplete="off" aria-hidden="true" class="honeypot" />

    @if (error()) {
      <p class="err">{{ error() }}</p>
    }

    <button (click)="send()" [disabled]="sending()" class="send-btn">{{ sending() ? 'Wysyłanie…' : 'Wyślij wiadomość' }}</button>
  </div>
}
